export default "__VITE_ASSET__24b4bb3c__"